import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";

export function PrivateRoute() {
  const { isAuth } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  if (!isAuth) navigate("/", { replace: true });

  return <Outlet />;
}
